import { TLoginStatus } from "context/UserContext";
import { ValidateToken } from "api/auth/ValidateToken";
import { useEffect, useState } from "react";
import { TUser } from "@sharedTypes/res.type";

export default function useUser() {
  const [loginStatus, setLoginStatus] = useState<TLoginStatus>("loading");
  const [sessionExpiration, setSessionExpiration] = useState(Infinity);
  const [user, setUser] = useState<TUser>({
    id: "",
    email: "",
    isAdmin: false,
    firstName: "",
    lastName: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setLoginStatus("invalid");
      return;
    }

    async function Token() {
      await ValidateToken()
        .then((data) => {
          console.log(data);
          localStorage.setItem("token", data.token);
          setSessionExpiration(data.expires);
          setUser({ ...data.user });
          setLoginStatus("logged in");
        })
        .catch((err) => {
          localStorage.removeItem("token");
          setLoginStatus("invalid");
          console.error(err);
        });
    }

    Token();
  }, []);

  return { loginStatus, sessionExpiration, user, setUser };
}
